<template>
  <!-- <div class="max-w-7xl mx-auto"> -->
  <div class="mx-auto">
    <RouterView></RouterView>
  </div>
</template>
